<rx-awareness-banner [showBannerButton]="false" [flat]="true">
	<div class="rx-mode-toggle-banner__content">
		<div>
			<p class="rx-awareness-banner-title rx-mode-toggle-banner__text">
				{{ 'RxMode.BannerTitleForNewRx' | translate }}
			</p>
			<p class="rx-awareness-banner-subtitle rx-mode-toggle-banner__text">
				{{ 'RxMode.BannerSubtitleForNewRx' | translate }}
			</p>
		</div>
	</div>
	<div class="rx-mode-toggle-banner__toggle">
		<tlk-slide-toggle [id]="'rx-mode-toggle'" [formControl]="modeControl" />
		<span class="rx-awareness-banner-subtitle">{{ 'RxMode.NewRxWorkflow' | translate }}</span>
	</div>
</rx-awareness-banner>
